<template>
  <div class="email-log-details-modal p-5">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="mb-0">Detalhes do Log de Email</h4>
      <button class="btn-close" @click="$emit('close')">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div v-if="loading" class="text-center py-5">
      <b-spinner variant="primary" />
    </div>

    <div v-else-if="log" class="log-details">
      <!-- Status -->
      <div class="detail-row">
        <label>Status:</label>
        <email-log-status-badge
          :status="log.status"
          :status-display="log.status_display"
        />
      </div>

      <!-- Tipo de Email -->
      <div class="detail-row">
        <label>Tipo:</label>
        <span>{{ log.email_type_display }}</span>
      </div>

      <!-- Destinatário -->
      <div class="detail-row">
        <label>Destinatário:</label>
        <div>
          <div class="font-weight-bold">{{ log.recipient_name || "-" }}</div>
          <div class="text-secondary">{{ log.recipient_email }}</div>
        </div>
      </div>

      <!-- Assunto -->
      <div class="detail-row">
        <label>Assunto:</label>
        <span>{{ log.subject }}</span>
      </div>

      <!-- De (From) -->
      <div class="detail-row">
        <label>De:</label>
        <span>{{ log.from_email }}</span>
      </div>

      <!-- Template -->
      <div class="detail-row">
        <label>Template:</label>
        <span>{{ log.template }}</span>
      </div>

      <!-- Datas -->
      <div class="detail-row">
        <label>Criado em:</label>
        <span>{{ formatDate(log.created_at) }}</span>
      </div>

      <div class="detail-row" v-if="log.sent_at">
        <label>Enviado em:</label>
        <span>{{ formatDate(log.sent_at) }}</span>
      </div>

      <div class="detail-row">
        <label>Atualizado em:</label>
        <span>{{ formatDate(log.updated_at) }}</span>
      </div>

      <!-- IDs -->
      <div class="detail-row">
        <label>ID do Log:</label>
        <span>{{ log.id }}</span>
      </div>

      <div class="detail-row" v-if="log.user_id">
        <label>ID do Usuário:</label>
        <span>{{ log.user_id }}</span>
      </div>

      <!-- Mensagem de Erro -->
      <div class="detail-row" v-if="log.error_message">
        <label>Erro:</label>
        <div class="error-message">
          {{ log.error_message }}
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <button class="btn btn-secondary" @click="$emit('close')">Fechar</button>
    </div>
  </div>
</template>

<script>
import EmailLogStatusBadge from "./EmailLogStatusBadge";
import { toHumanDate } from "@/functions/helpers";

export default {
  name: "EmailLogDetailsModal",
  components: {
    EmailLogStatusBadge
  },
  props: {
    logId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      log: null,
      loading: false
    };
  },
  mounted() {
    this.fetchLogDetails();
  },
  methods: {
    async fetchLogDetails() {
      this.loading = true;
      try {
        await this.$store.dispatch("emailLogs/getDetails", this.logId);
        this.log = this.$store.state.emailLogs.emailLog;
      } catch (error) {
        this.$message.error("Erro ao carregar detalhes do log");
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      return toHumanDate(date);
    }
  }
};
</script>

<style lang="scss" scoped>
.email-log-details-modal {
  .btn-close {
    background: none;
    border: none;
    font-size: 20px;
    color: #77788e;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(119, 120, 142, 0.1);
    }
  }

  .log-details {
    .detail-row {
      display: flex;
      padding: 16px 0;
      border-bottom: 1px solid rgba(210, 208, 216, 0.5);

      &:last-child {
        border-bottom: none;
      }

      label {
        font-weight: 600;
        color: #3b3b4a;
        min-width: 150px;
        margin-bottom: 0;
      }

      span,
      div {
        color: #57586b;
        flex: 1;
      }

      .error-message {
        background-color: rgba(245, 101, 101, 0.1);
        color: #c53030;
        padding: 12px;
        border-radius: 4px;
        font-family: monospace;
        font-size: 13px;
      }
    }
  }
}
</style>
